import { CreateColdOfferPayload, Quote } from '../types'
import apiClient from '../../../../services/api-client'
import { AxiosResponse } from 'axios'

export async function createColdOffer(
  payload: CreateColdOfferPayload,
): Promise<AxiosResponse<Quote>> {
  // Destructure necessary fields from the payload
  const { accounts, products, note, delivery, isLocked, expiresOn } = payload

  // Ensure required fields are present
  if (!accounts.length || !products.length || !delivery) {
    throw new Error('Missing required fields')
  }

  try {
    // Set up the request data based on the API contract
    const data: CreateColdOfferPayload = {
      accounts,
      note,
      isLocked,
      expiresOn,
      delivery: delivery,
      products: products.map((product) => ({
        productId: product.productId,
        itemId: product.itemId,
        description: product.description,
        quantity: product.quantity,
        basePriceExcGst: product.originalPriceExcGst
          ? product.originalPriceExcGst
          : product.basePriceExcGst, // need check for 0 price
        discountedPriceExcGst: product.discountedPriceExcGst,
        discountedPriceIncGst: product.discountedPriceIncGst,
        editedPriceExcGst: product.editedPriceExcGst,
      })),
    }

    // Send POST request to create a quote
    const response = await apiClient.post<Quote, CreateColdOfferPayload>('/quotes/offer', data)

    if (!response.status.toString().startsWith('2')) {
      console.error('Failed to create quote:', response.statusText)
    }

    return response
  } catch (error) {
    console.error('Error occurred while creating quote:', error)
    throw error
  }
}
